import * as classnames from 'classnames'
import * as React from 'react'

import CardArea from './cardArea/cardArea'

import * as styles from './itemCardsLayout.module.css'

interface IProps {
  viewType?: string
  children?: React.ReactNode
}

interface IItemCardsLayout extends React.SFC<IProps> {
  CardArea: typeof CardArea
}

const ItemCardsLayout: IItemCardsLayout = ({ viewType, children }) => {
  const className = classnames(styles.root, {
    [styles.listView]: viewType === 'list'
  })
  return <ul className={className}>{children}</ul>
}

ItemCardsLayout.CardArea = CardArea
ItemCardsLayout.CardArea.displayName = 'ItemCardsLayout.CardArea'

export default ItemCardsLayout
